<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h1>Logs ({{ total }})</h1>
      <div>
        <form method="post" @submit.prevent="fetchLogs(formData.search)">
          <v-text-input
            placeholder="word.search"
            v-model="formData.search"
          />
        </form>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
      <tr>
        <th>{{ $t('word.timestamp') }}</th>
        <th>{{ $t('word.message') }}</th>
        <th>{{ $t('word.log_level') }}</th>
        <th>{{ $t('word.location') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(log, index) in logs" :key="index">
        <td>{{ stringToPrettyDateTime(log.timestamp, true) }}</td>
        <td>{{ log.message }}</td>
        <td>
          <div class="badge" :class="LOG_LEVEL_COLORS[log.level]">
            {{ log.level }}
          </div>
        </td>
        <td>{{ log.location }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { fetchLogs } from '@/admin/api';
import { stringToPrettyDateTime } from '@/common/utils/formatting';
import TextInput from '@/common/components/inputs/TextInput.vue';

const LOG_LEVEL_COLORS = {
  DEBUG: 'bg-secondary text-white',
  INFO: 'bg-info text-white',
  WARNING: 'bg-warning text-dark',
  ERROR: 'bg-danger text-white',
  CRITICAL: 'bg-danger text-white',
};

export default {
  name: 'LogList',
  components: {
    'v-text-input': TextInput,
  },
  data() {
    return {
      LOG_LEVEL_COLORS,
      logs: [],
      page: 1,
      total: null,
      formData: {
        search: '',
      },
    };
  },
  methods: {
    stringToPrettyDateTime,
    async fetchLogs(search) {
      const response = await fetchLogs(this.page, search);
      this.total = response.data.total;
      this.logs = response.data.results;
    },
  },
  created() {
    this.fetchLogs();
  },
};
</script>
